import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { Store } from '../../../../../services/store';
import { toVoid } from '../../../../../utils/void';
import { BomItemOrdersProvider } from './bom-item-orders.provider';
import { BomItemOrderDto } from './bom-item-order.dto';

export interface BomItemOrdersState {
  loading: boolean;
  items: BomItemOrderDto[] | undefined;
}

const INITIAL_STATE: BomItemOrdersState = {
  loading: false,
  items: undefined
};

@Injectable({ providedIn: 'root' })
export class BomItemOrdersStore extends Store<BomItemOrdersState> {
  constructor(private provider: BomItemOrdersProvider) {
    super(INITIAL_STATE);
  }

  init(bomItemId: number | undefined): Observable<void> {
    if (bomItemId === undefined) {
      // item not saved in backend yet (/bom/new) — no order can reference it
      this.update(state => ({ ...state, loading: false, items: [] }));
      return of(undefined);
    }

    this.update(state => ({ ...state, loading: true }));

    return this.provider.getOrders(bomItemId)
      .pipe(
        tap(items => {
          this.update(state => ({
            ...state,
            loading: false,
            items
          }));
        }),
        toVoid()
      );
  }
}
